<template>
  <div class="q-pa-md">
    <div class="square_titulo_vacio">
      <div class="square_titulo_valores_vacio" ID="Div9" runat="server"></div>
    </div>
    <div class="q-pa-md row items-start">
      <q-card class="us_my-card">
        <q-card-section class="us_card_titulo">
          <div class="us_card_titulo_text">Validación Usuario Interno</div>
        </q-card-section>
        <q-card-actions align="start">
          <div class="flex-item_30">
            <q-icon name="info" />* Dato Obligatorio
          </div>
          <div class="flex-item_60">
            <q-chip
              large
              clickable
              @click.stop="validar_usuario"
              color="lime"
              class="ma-2"
            >
              Registrar
            </q-chip>
          </div>
          <div class="flex-item_60">
            <q-field borderless ref="field" :value="email">
              <q-input
                v-model="email"
                maxlength="50"
                emit-value
                input-debounce="0"
                :rules="[(val) => validateEmail(email) || 'Email no válido']"
                label="*Correo electrónico"
                class="col-12"
              >
              </q-input>
            </q-field>
          </div>
          <div class="flex-item_30"></div>
        </q-card-actions>
      </q-card>
    </div>

    <!--ALERT CUADRO DE DIÁLOGO-->
    <q-dialog v-model="mostrar_mensaje">
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Aviso:</div>
        </q-card-section>

        <q-card-section class="q-pt-none"> {{ mensaje }}</q-card-section>
        <q-card-actions align="right">
          <q-btn
            flat
            v-close-popup
            @click="comprobar_accion"
            round
            dense
            label="Ok"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <cargando :contenido_mensaje="mensaje_cargando" />
  </div>
</template>

<script>
import { Cookies } from 'quasar';
import {
  QInput,
  QSelect,
  QCard,
  QList,
  QField,
  QItem,
  QItemSection,
  QItemLabel,
  QCardSection,
  QCardActions,
  QBtnToggle,
  QCheckbox,
  QTable,
  QTh,
  QTr,
  QTd,
  QToggle,
  ClosePopup,
  QDialog
} from 'quasar';
import Cargando from '@/components/shared/components/Cargando';

export default {
  mounted () {
    this.mensaje = '';
    this.mostrar_mensaje = false;

    this.isLoading = false;
    this.$store.commit('TSZ/setOffline', false);
  },

  methods: {
    comprobar_accion () {
      if (this.ok) {
        this.$router.push({ name: 'login' });
      }
    },
    validateEmail (email_) {
      var re =
        /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },

    validar_usuario () {
      if (this.email === '' || !this.validateEmail(this.email)) {
        this.mostrar_mensajes(
          'Debe introducir un correo electrónico correcto',
          'red'
        );
      } else {
        this.isLoading = true;
        this.$store.commit('TSZ/setOffline', true);

        this.Datos_user.mail = this.email;
        this.Datos_user.isExternal = false;
        this.Datos_user.appName = 'TSZ';

        this.$store.commit('TSZ/setDatosUsuario', this.Datos_user);
        this.$store.commit('TSZ/setDatosProfile', this.Datos_profile);
        this.$store
          .dispatch('TSZ/postDatosValidarUsuario')
          .then((response) => {
            this.ok = true;
            this.mostrar_mensajes(
              'Confirme su correo electrónico para completar el registro',
              'blue'
            );
          })
          .catch((err) => {
            this.mostrar_mensajes(err.response.data);
          });
        this.isLoading = false;
        this.$store.commit('TSZ/setOffline', false);
      }
    },
    validateEmail (email_) {
      var re =
        /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
      this.mensaje = mensaje;
      this.mostrar_mensaje = true;
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.showError(mensaje, color, timeout);
      /* this.mensaje= mensaje;
        this.mostrar_mensaje=true; */
    },

    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  },

  data () {
    return {
      email: '',
      mostrar_mensaje: false,
      mensaje: '',
      mensaje_cargando: 'registrando',
      ok: false,
      Datos_user: {
        mail: '',
        isExternal: null,
        appName: null,
        password: null,
        id: 0
      },
      Datos_profile: {
        nombre: null,
        apellidos: null,
        empresa: null,
        telefono: null,
        id: 0
      }
    };
  },

  components: {
    Cargando,
    QInput,
    QSelect,
    QCard,
    QList,
    QField,
    QCardSection,
    QCardActions,
    QBtnToggle,
    QCheckbox,
    QTable,
    QTh,
    QTr,
    QTd,
    QToggle,
    ClosePopup,
    QDialog
  }
};
</script>
